// Need to use the React-specific entry point to import createApi
import { createApi } from "@reduxjs/toolkit/query/react";
import { encryptedBaseQueryWithReauth } from "../utilities/encryptedBaseQuery";

export const practiceQaApi = createApi({
  reducerPath: "practiceQaApi",
  baseQuery: encryptedBaseQueryWithReauth(process.env.REACT_APP_LOCAL_URL),
  // baseQuery: encryptedBaseQueryWithReauth(process.env.REACT_APP_LOCAL_URL),
  tagTypes: ["getPracticeQa", "getPackage"],
  endpoints: (builder) => ({
    getPracticeQa: builder.query({
      query: (endpoint) => `${endpoint}`,
      providesTags: ["getPracticeQa"],
    }),

    getPracticeQaPackage: builder.query({
      query: (endpoint) => `${endpoint}`,
      providesTags: ["getPackage"],
    }),

    createPracticeQa: builder.mutation({
      query: ({ endpoint, data }) => {
        return {
          url: endpoint,
          method: "POST",
          body: data,

        };
      },
      invalidatesTags: ["getPracticeQa"],
    }),
    updatePracticeQa: builder.mutation({
      query: ({ endpoint, updatedData }) => {
        return {
          url: endpoint,
          method: "PATCH",
          body: updatedData,

        };
      },
      invalidatesTags: [],
    }),

    createPackage: builder.mutation({
      query: ({ endpoint, data }) => {
        return {
          url: endpoint,
          method: "POST",
          body: data,

        };
      },
      invalidatesTags: [],
    }),
    getPracticeQaAnalytics: builder.query({
      query: (endpoint) => `${endpoint}`,
    }),
  }),
});

export const {
  useGetPracticeQaQuery,
  useGetPracticeQaAnalyticsQuery,
  useGetPracticeQaPackageQuery,
  useCreatePackageMutation,
  useCreatePracticeQaMutation,
  useUpdatePracticeQaMutation
} = practiceQaApi;
